import Vue from "vue";
import VueRouter from "vue-router";

import bmRoutes from "@/router/bm.route";
import userRoutes from "@/router/user.route";
import profileRoutes from "@/router/profile.route";
import scheduleRoutes from "@/router/schedule.route";
import authRoutes from "@/router/auth.route";
import bannerRoute from "@/router/banner.route";
import serviceRoutes from "@/router/service.route";
import personsRoute from "./persons.route";
import recoverPass from "./recover.route";
import productRoute from "./product.route";
import supplierRoutes from "./supplier.route"
import financialRoutes from "@/router/financial.route"
import checkout from "@/router/checkout.route";
import receipments from "@/router/receivements.route";
import chargeRoutes from "@/router/charge.route";
import lynduspassRoutes from "@/router/lynduspass.route";
import reportsRoutes from "@/router/reports.route";

Vue.use(VueRouter);

const routes = [
    ...authRoutes,
    ...recoverPass,
    {
        path: "/",
        name: "home",
        redirect: 'schedule',
        component: () => import("../views/Home"),
        meta: {
            authRequired: true
        },
        children: [
            ...bmRoutes,
            ...userRoutes,
            ...profileRoutes,
            ...scheduleRoutes,
            ...bannerRoute,
            ...personsRoute,
            ...productRoute,
            ...serviceRoutes,
            ...supplierRoutes,
            ...financialRoutes,
            ...checkout,
            ...chargeRoutes,
            ...receipments,
            ...lynduspassRoutes,
            ...reportsRoutes
        ]
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
